import React from 'react';

export default function TeachingsForm(props){
  return(
    <div>
    {props.isLoggedIn ? 
    <div>
      <h1>Admin only</h1>
      <h2>Submit new Catechism Teaching</h2>
      <form onSubmit={props.submitTeaching}>
        <label htmlFor='title'>Title</label>
        <input type='text' id='title' value={props.teachingInputs.title} onChange={props.teachingFormChange} /><br/>

        <label htmlFor='bibleVerse'>Bible Verse (book name, chapter, and verse)</label>
        <input type='text' id='bibleVerse' value={props.teachingInputs.bibleVerse} onChange={props.teachingFormChange} /><br/>

        <label htmlFor='reading'>Bible Passage Reading</label>
        <input type='text box' id='reading' value={props.teachingInputs.reading} onChange={props.teachingFormChange} /><br/>

        <label htmlFor='cccParagraph'>CCC Paragraph #</label>
        <input type='number' id='cccParagraph' value={props.teachingInputs.cccParagraph} onChange={props.teachingFormChange} /><br/>

        <label htmlFor='content'>CCC Text</label><br/>
        <textarea id='content' value={props.teachingInputs.content} onChange={props.teachingFormChange} /><br/>

        <label htmlFor='prayer'>Reflection and Prayer</label><br/>
        <textarea id='prayer' value={props.teachingInputs.prayer} onChange={props.teachingFormChange} /><br/>

        <label htmlFor='temptation'>Struggle or Temptation</label>
        <select id='temptation' value={props.teachingInputs.temptation} onChange={props.teachingFormChange}>
          <option id='temptation' value='Pornography/Lust'>Pornography/Lust</option>
           <option id='temptation' value='Alcohol Abuse'>Alcohol Abuse</option>
           <option id='temptation' value='Drug Abuse'>Drug Abuse</option>
           <option id='temptation' value='Tobacco Abuse'>Tobacco Abuse</option>
           <option id="temptation" value="Physical Illness">Physical Illness</option>
           <option id="temptation" value="Mental Illness">Mental Illness</option>
        </select><br/>
        <input type='submit' value='submit' /><br/>
      </form>
    </div> : <h1>Acess Denied</h1> 
    }

  </div>
    )
  }
